import { useState, useCallback, useMemo } from 'react';

interface ServerPaginationProps {
  currentPage: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

interface UseServerPaginationReturn {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  setTotalItems: React.Dispatch<React.SetStateAction<number>>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  resetPage: () => void;
  serverPaginationProps: ServerPaginationProps;
}

export function useServerPagination(initialPageSize = 10): UseServerPaginationReturn {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [totalItems, setTotalItems] = useState(0);

  const resetPage = useCallback(() => setCurrentPage(1), []);

  const serverPaginationProps = useMemo<ServerPaginationProps>(() => ({
    currentPage,
    totalItems,
    pageSize,
    onPageChange: setCurrentPage,
    onPageSizeChange: (size: number) => {
      setPageSize(size);
      setCurrentPage(1);
    },
  }), [currentPage, totalItems, pageSize]);

  return { currentPage, pageSize, totalItems, setTotalItems, setCurrentPage, setPageSize, resetPage, serverPaginationProps };
}
